import { format, isSameDay } from 'date-fns';
import ArticleSoMeRow from "src/components/articlesomerow/ArticleSoMeRow";
import getDocumentDate from "src/lib/client/getDocumentDates";
import styles from './Byline.module.css';
import IAuthor from 'src/lib/types/Author';
import IFilmnytt from "src/lib/types/Filmnytt";
import ISettings from "src/lib/types/Settings";

//#region [Props]
type BylineProps = {
    document: IFilmnytt;
    settings: ISettings;
    isAdContent?: boolean;
};
//#endregion

//#region [Component]
export default function Byline({ document, settings, isAdContent }: BylineProps) {
    // <Byline author={document.author as IAuthor | undefined} source={document.source}  />
    const author = document.author as IAuthor | undefined;
    const firstPublishedDate = document.firstPublishedAt ?? document.createdAt ?? document._createdAt;
    const updatedDate = document.updatedAt ?? document.eceLastUpdated ?? document._updatedAt;
    const _publishedAt: Date = getDocumentDate(firstPublishedDate, "1900-01-01T00:00:00.000Z")!;
    const _updatedAt: Date | undefined = getDocumentDate(updatedDate);
    return <div className={styles.SBylineContainer}>
        <div className={styles.SByline}>
            {!document.ntbId && <a className={styles.SAuthor} rel="author" href={`mailto:${(author?.email ?? 'desk@filmweb.no')}`}>{author?.name ?? "Redaksjonen"}</a>}
            {document.source && <div className={styles.SSource}>{document.source}</div>}
            <div>
                Publisert: <time dateTime={format(_publishedAt, 'dd.MM.yyyy')}>{format(_publishedAt, 'dd.MM.yyyy')}</time>
                {_updatedAt && !isSameDay(_publishedAt, _updatedAt) && <div>
                    Sist oppdatert: <time dateTime={format(_updatedAt, 'dd.MM.yyyy')}>{format(_updatedAt, 'dd.MM.yyyy')}</time>
                </div>}
            </div>
        </div>
        {!isAdContent && <ArticleSoMeRow className={styles.SArticleSoMeRow} label={settings.articleSoMeLabelByline?.trim() ?? "Følg oss:"} />}
    </div>;

}
//#endregion

//#region [Styles]
//#endregion
